import { MODAL_APPEARANCE_TIME } from '@shared/config/style/modal';
import { SELECT_LIST_EMPTY_TEXT_HIDE_CLASS_NAME } from '@shared/ui/select/constants';
import { createGlobalStyles } from 'goober/global';

export const GlobalStyles = createGlobalStyles`
    body {
        margin: 0;
    }
    * {
        box-sizing: border-box;
    }

    .rf-modal__content {
        margin: 0 !important;
        padding: 0 32px !important;
        flex-grow: 1;
    }

    .rf-modal__footer {
        padding-top: 24px !important;
    }

    .rf-tabs__content {
        flex-grow: 1;
        margin-top: 0 !important;
    }

    .rf-modal {
        opacity: 0;
        transition: opacity 0.${MODAL_APPEARANCE_TIME}s ease;
    }

    .rf-tabs {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
    }

    .rf-form-group__message--invalid:has(span:empty) {
        margin: 0;
    }
    
    .rf-popper__content {
        border-radius: 16px !important;
    }

    .${SELECT_LIST_EMPTY_TEXT_HIDE_CLASS_NAME} .rf-select-menu__empty {
        display: none;
    }
    
`;
